import { Component, AfterViewInit, Input,EventEmitter,Output} from '@angular/core';
import * as d3 from 'd3';

@Component({
	selector: 'app-subpareto-chart',
	templateUrl: './SubParetoChart.html'
})

export class SubParetoChartComponent {
	@Input()
	GraphData: any;
	@Input()
	GraphId: any;
	
	Xaxis=[];
    myData=[];
    viewData = [];
	ngOnChanges(){
		this.RenderPareto();
	   }
	RenderPareto() {
		this.myData=[];
        this.createBarData(this.GraphData)
        var data = [];
        
        data=[]
        data = this.myData;
        var graphId = this.GraphId           
        var w=document.getElementById(graphId).offsetWidth - 20,
		h=280//document.getElementById('container_pareto').offsetHeight;
		var margin = {
			top: 30,
			right: 50,
			bottom: 90,
			left: 50
		},
		margin2 = {
			top: h-70,
			right: 50,
			bottom: 30,
			left: 50
		}
		var Swidth = w - margin.left - margin.right,
		Sheight = h - margin.top - margin.bottom,
		Sheight2 = h - margin2.top - margin2.bottom;
		
		d3.select('#'+graphId).html("");
		d3.select("#"+graphId)
		.attr("width", w )
		.attr("height", h)
		
		var x = d3.scaleBand()
		.domain(data.map(function(d) {
			return d.name
		}))
		.range([0, Swidth]);
		
		var x2 = d3.scaleBand()
		.domain(data.map(function(d) {
			return d.name
		}))
		.range([0, Swidth]);
		
		var x3 = d3.scaleLinear()
		.domain([0, data.length])
		.range([0,Swidth]);
		
		var yMaxValue=(d3.max(data, function(d) {return d.val}))/5;
		const yValues = [0,yMaxValue,yMaxValue*2,yMaxValue*3,yMaxValue*4,yMaxValue*5];

		var y = d3.scaleLinear()
		.domain([d3.min(yValues), d3.max(yValues)])
		.range([Sheight, 0]);
		
		var y2 = d3.scaleLinear()
		.domain([0, d3.max(data, function(d) {
			return d.val
		})])
		.range([Sheight2, 0]);
		
		var y3 = d3.scaleLinear()
		.domain([0, 100])
		.range([Sheight, 0]);
		
		
		//now calculate cumulative % from the cumulative amounts & total, round %
		var totalAmount = 0;
		for(var i = 0; i < data.length; i++){		
			totalAmount += data[i]["val"];		
			data[i]['Cumulative'] = totalAmount		
		}
		for(var i = 0; i < data.length; i++){
			data[i]['Percentage'] = (data[i]['Cumulative'] / totalAmount);
			data[i]['Percentage'] = parseFloat(data[i]['Percentage'].toFixed(2)) * 100;
		}
		
		var svg = d3.select("#"+graphId)      
		.append("svg")
		.attr("width", Swidth + margin.left + margin.right)
		.attr("height", Sheight + margin.top + margin.bottom);
		
		svg.append("defs").append("clipPath")
		.attr("id", graphId+"clipS")
		.append("rect")
		.attr("width", Swidth)
		.attr("height", Sheight);
		
		var Sfocus = svg.append("g")
		.attr("class", "focusS")
		.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
		
		
		var xAxis = d3.axisBottom(x)
		
		var xAxis2 = d3.axisBottom(x2);
		
		Sfocus.append("g")
		.attr("class", "Sxaxis")
		.attr("transform", "translate(0," + Sheight + ")")
		.call(xAxis)
		.selectAll('text')
        .style('text-anchor', 'middle')
        .attr('fill', '#015b63')
        .style('font-size', '10px')
        .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
        .style('white-space', 'nowrap')
        .style('cursor', 'default')
        .attr('y', '5')
        //.attr('dy', '0.71em')
        .attr('x', '-5')
        .attr('transform', d => 'rotate(0)')
        .text(d => {
            if (d.length > 8) {
                d = d.substring(0, 7) + '...';
            }
            return d;
        })
        .append('title')
        .text(d => d.length > 12 ? d : null);
		
		// Add the Y Axis
		const yAxis = d3.axisLeft()
		  .scale(y)
		  .tickValues(yValues)
		  .tickSize(-Swidth, 0, 0)
		  
		Sfocus.append("g")
		.classed('yaxis', true)
		.call(yAxis)
		
        //.ticks(7));
		
		svg.append("text")
			.attr("transform", "rotate(-90)")
			.attr("y",10)
			.attr("x",0-(Sheight/1.5))
			.style("text-anchor", "middle")
			.style("fill",'rgb(1, 91, 99)')
			.style("font-size",'12px')
			.style("font-family",'Graphik Medium')
			.style("font-weight",'bold')
			.text("Occurrence");

			svg.append("text")
			.attr("transform", "rotate(-90)")
			.attr("y",Swidth+margin.left+margin.top +10)
			.attr("x",0-(Sheight/1.5))
			.style("text-anchor", "middle")
			.style("fill",'rgb(1, 91, 99)')
			.style("font-size",'12px')
			.style("font-family",'Graphik Medium')
			.style("font-weight",'bold')
			.text("Pareto %");

			svg.append("text")
			.attr("transform", "rotate(0)")
			.attr("y",Sheight+margin.left+20)
			.attr("x",(Swidth/2)+margin.left)
			.style("text-anchor","middle")
			.style("fill",'rgb(1, 91, 99)')
			.style("font-size",'12px')
			.style("font-family",'Graphik Medium')
			.style("font-weight",'bold')
			.text("Keyword");
			
		Sfocus.append("g")
		.attr("class", "Saxis")
		.attr("transform", "translate(" + [Swidth, 0] + ")")
		.call(d3.axisRight(y3)
		.ticks(5))
		
		Sfocus.selectAll('.domain')
		.style("opacity" ,"0")

		Sfocus.selectAll('line')
		.attr('stroke', '#e6e6e6')
		
		d3.selectAll("text")
		.attr("color","#015b63")

		var focus_groupS = Sfocus.append("g");
		focus_groupS.attr("clip-path", "url(#"+graphId+"clipS)");
		
		var rects = focus_groupS.selectAll('rect')
		.data(data);
		
		var xscale_bw = 24;
		const rx = xscale_bw / 2, ry = xscale_bw / 2;
		//********* Bar Chart 1 ****************
		var newRects 
		newRects = rects.enter();
		newRects
		// .append('rect')
		// .attr('class', 'Sbar SmainBars')
		// .attr('x', function(d, i) {
		// 	return x(d.name) + x.bandwidth()/2;
		// })
		// .attr('y', function(d, i) {
		// 	return y(d.val);
		// })
		// .attr('height', function(d, i) {
		// 	return Sheight - y(d.val)
		// })
		.append('path')
      .attr('class', 'bar')
      .attr("d", d => `
        M${x(d.name) + x.bandwidth() / 2 - rx},${y(d.val) + ry}
        a${rx},${ry} 0 0 1 ${rx},${-ry}
        h${xscale_bw - 2 * rx}
        a${rx},${ry} 0 0 1 ${rx},${ry}
        v${h - y(d.val) - ry}
        h${-(xscale_bw)}Z
      `)
		.attr('opacity', 0.85)
		.style('fill', '#6DDBDC')
		.on('mouseover', function (d, i) {
			d3.select(this).style('cursor', 'pointer');
			var tooltip = svg
				.append("g")
				.style("cursor", "pointer")
				.attr("class", "tooltip")
				.style("opacity", 1)
			tooltip.append("rect")
				.attr("width", 90)
				.attr('height', 60)
				.style('fill', '#FFFFFF')
				.style('pointer-events', 'none')
				.style('stroke', d3.select(this).style('fill'))
				.style('stroke-width', 2)
				.style('fill-opacity', 0.8);
			var textSvg = tooltip.append("text")
				.attr('x', 7)
				.attr('y', 15)
				.style('pointer-events', 'none')
				.style('fill', '#333333')
				.style('font-size', '12px')
				.style('color', '#333333');
			textSvg.append("tspan")
				.style('font-size', '11px')
				.style('pointer-events', 'none')
				.style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
				.style('font-weight', 'bold')
				.text(d.name)
			textSvg.append("tspan")
				.attr('x', 7)
				.attr('dy', 15)
				.style('pointer-events', 'none')
				.style('fill', d3.select(this).style('fill'))
				.html('&#x25cf') //&#9679; //&bull;
			textSvg.append("tspan")
				.attr('dx', 0)
				.style('pointer-events', 'none')
				.style('font-size', '11px')
				.style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
				.style('font-weight', 'bold')
				.style('font-weight', 'bold')
				.text(d.val)
			textSvg.append("tspan")
				.attr('x', 7)
				.attr('dy', 15)
				.style('pointer-events', 'none')
				.style('fill', '#267db3')
				.html('&#x25cf') //&#9679; //&bull;
			textSvg.append("tspan")
				.attr('dx', 0)
				.style('pointer-events', 'none')
				.style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
				.style('font-weight', 'bold')
				.text(d.Percentage.toFixed(2)+"%");
		})
			.on("mousemove", function (d) {
				d3.select(this).style('opacity', 1)
				d3.select(this).style('cursor', 'pointer');
				var mousePosition = d3.mouse(this);
				var x = mousePosition[0];// + width / 2;
				var y = mousePosition[1];// + height / 2;
				var text = d3.select(this.closest('svg')).select('.tooltip text');
				//svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
				//    console.log(element.getBBox().width);
				//})
				var bbox = text.node().getBBox();
				d3.select(this.closest('svg'))
					.select('.tooltip rect')
					.attr("width", bbox.width + 15)
				if (x - bbox.width / 2 < 0) {
					x = bbox.width / 2;
				}
				else if (Swidth - x - bbox.width / 2 < 0) {
					x = Swidth - bbox.width / 2;
				}
				if (y - bbox.height / 2 < 0) {
					y = bbox.height * 2;
				}
				else if (Sheight - y - bbox.height / 2 < 0) {
					y = Sheight - bbox.height / 2;
				}
				d3.select(this.closest('svg'))
					.select('.tooltip')
					.style("opacity", 1)
					.attr('transform', `translate(${x + 10}, ${y - 20})`);
			})
			.on("mouseout", function (d) {
				d3.select(this.closest('svg'))
					.select('.tooltip').style('display', 'none');
				d3.select(this.closest('svg'))
					.select(".tooltip").remove();
				d3.select(this)//.selectAll('path')
					.style("opacity", 1);
			})
	// 	.on("mouseover", function(d){
	// 		tooltip.html('<b>'+d.name+'</b>:<br><svg height="10" width="10"><circle cx="5" cy="5" r="4" stroke-width="3" fill="rgb(164, 210, 248)" /></svg>' + d.val+'<br><svg height="10" width="10"><circle cx="5" cy="5" r="4" stroke-width="3" fill="rgb(169, 167, 251)" /></svg>' +d.Percentage.toFixed(2)+"%")
	// 		tooltip.style("visibility", "visible");
	// 	})
			
	//   .on("mousemove", function()
	//   { 
	// 	 tooltip.style("top", (d3.event.pageY-10)+"px").style("left",(d3.event.pageX+10)+"px");
	// })
    //   .on("mouseout", function(){
	// 	  tooltip.style("visibility", "hidden");
	// 	});
		

		
		//********* Parato curve *****************	
		var Sguide = d3.line()
		//.x(function(d, i) { if ( x(d.name) === undefined){ return 0; }else return x(d.name) + x.bandwidth()/2 }) 
		.x(function(d, i) { return x(d.name) + x.bandwidth()/2 }) 
		.y(function(d) { return y3(d.Percentage); }) 
		//.defined(function(d) { return x(d.name); })
		//.curve(d3.curveMonotoneX)				
		
		var line = newRects.append('path')
		.datum(data)
		.attr('d', Sguide)
		.attr('class', 'lineS')
		.attr('fill','none')
		.attr('stroke','#267db3')
		.attr('stroke-width', '2');


	
			
		newRects.selectAll(".dotS")
		.data(data)
		.enter()
		.append("circle") // Uses the enter().append() method
		.attr("class", "dotS") // Assign a class for styling
		.attr("cx", function(d, i) { return x(d.name) + x.bandwidth()/2 })
		.attr("cy", function(d) { return y3(d.Percentage) })
		.attr('stroke-width','2')
		.attr('stroke','white')
		.attr("r", 3)

		newRects.selectAll(".dotS")
		.data(data)
		.enter()
		.append("circle") // Uses the enter().append() method
		.attr("class", "dotS") // Assign a class for styling
		.attr("cx", function(d, i) { return x(d.name) + x.bandwidth()/2 })
		.attr("cy", function(d) { return y3(d.Percentage) - 5 })
		.attr('fill','#267db3')
		.attr("r", 1)
		
		
		
		//********* Brush Bar Chart ****************
		// var brushRects //= brushRects
		
		// brushRects.enter().append('rect')
		// .attr('class', 'Sbar SmainBars')
		// .attr('x', function(d, i) {
		// 	return x2(d.name);
		// })
		// .attr('y', function(d, i) {
		// 	return y2(d.val);
		// })
		// .attr('height', function(d, i) {
		// 	return Sheight2 - y2(d.val)
		// })
		// .attr('opacity', 0.85)
		// .attr('width', 10)
		// .attr("transform", "translate(" + 4 + ",0)")
		// .style('fill', 'rgb(164, 210, 248)')
		// .style('margin-left', '2px')
		// .style('margin-right', '2px')

		// Scontext.append("g")
		// .attr("class", "brushS")
		// .call(brush1)
		// .call(brush1.move,x.range());
		
			
		//create brush function redraw scatterplot with selection
		function brushed2() {
			if (d3.event.sourceEvent && d3.event.sourceEvent.type === "zoom") return; // ignore brush-by-zoom
			
			// get bounds of selection
			var sS = d3.event.selection,
			nD = [];
			x2.domain().forEach((d)=>{
				var pos = x2(d) + x2.bandwidth()/2;
				if (pos > sS[0] && pos < sS[1]){
					nD.push(d);
				}
			});
			
			x.domain(nD);
			
			var current_componentsS =  nD.length
			
			// ****** bar ***********
			Sfocus.selectAll(".SmainBars")
			.style("opacity", function(d){
				return x.domain().indexOf(d.name) === -1 ? 0 : 100;
			})
			.attr("x", function(d) {
				return x(d.name);		
			})
			.attr("y", function(d) {
				return y(d.val);
			})
			.attr('height', function(d, i) {
				return Sheight - y(d.val)
			})
			.attr('opacity', 0.85)
			.style('margin-left', '2px')
			.style('margin-right', '2px')
			.attr('width', (Swidth / ( current_componentsS)) - 3);
			
			// ****** dot and line ***********
			Sfocus.selectAll('.lineS')			
			.attr("d", Sguide.defined( function(d) { return x(d.name) + x.bandwidth()/2; } ));
			
			
			// Sfocus.selectAll(".dotS")
			// .style("opacity", function(d){
			// 	return x.domain().indexOf(d.name) === -1 ? 0 : 100;
			// })
			// .attr("cx", function(d) {				
			// 		return x(d.name)+ (x.bandwidth()/2);		
			// })
			// .attr("cy", function(d) {
			// 	return y3(d.Percentage);
			// })
				
			Sfocus.select(".Sxaxis").call(xAxis).selectAll('text')
			.style('text-anchor', 'end')
			.attr('fill', '#015b63')
			.style('font-size', '10px')
			.style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
			.style('white-space', 'nowrap')
			.style('cursor', 'default')
			.attr('y', '5')
			//.attr('dy', '0.71em')
			.attr('x', '-5')
			.attr('transform', d => 'rotate(0)')
			.text(d => {
				if (d.length > 8) {
					d = d.substring(0, 7) + '...';
				}
				return d;
			})
			.append('title')
			.text(d => d.length > 12 ? d : null);;
			
			Sfocus.selectAll('line')
		.attr('stroke', '#e6e6e6');
			// svg.select(".zoom").call(zoomS.transform, d3.zoomIdentity
			// .scale(Swidth / (sS[1] - sS[0]))
			// .translate(-sS[0], 0));
		}
		
		// function zoomed() {
		// 	return
		// }
		
		  
    }
    createBarData(data:any){
		this.Xaxis = Object.keys(data)
		for(var i=0;i<this.Xaxis.length;i++){
			this.myData.push({name:this.Xaxis[i],val:data[this.Xaxis[i]]}) 
		 }
	  }
}
